import {SimpleStat} from './simple-stat';

export class SiteStat extends SimpleStat {
  label: string = '';
  siteId: number | null = null;
  siteLang: string = 'fr';
}
